function resetRequestMutation(resetRequest) {
  const {subDomain, username} = resetRequest
  return `
    mutation {
      resetPasswordRequest(params: {
        subDomain: "${subDomain}",
        username: "${username}",
      })
    }
  `
}

function resetMutation(password, resetToken) {
  return `
    mutation {
      resetPassword(params: {
        newPassword: "${password}",
        resetToken: "${resetToken}"
      })
    }
  `
}

function updateMutation(current, newPassword) {
  return `
    mutation {
      changePassword(params: {
        password: "${current}",
        newPassword: "${newPassword}",
      })
    }
  `
}

const passwordQueries = {
  methods: {
    async updatePasswordMutation(current, newPassword) {
      try {
        const result = await this.graphQuery(updateMutation(current, newPassword))
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async resetPasswordRequest(resetRequest) {
      try {
        const result = this.graphQuery(resetRequestMutation(resetRequest), undefined, true)
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async resetPasswordMutation(newPassword, resetToken) {
      try {
        const result = await this.graphQuery(resetMutation(newPassword, resetToken), undefined, true)
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default passwordQueries
